import { SET_NEXT_CHALLENGE_TIME } from '../actions/game'

const defaultState = { time : null }
export default function robot(state = defaultState, action) {
  switch (action.type) {
    case SET_NEXT_CHALLENGE_TIME:
      return Object.assign(state, { time: action.time })
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./reducers/nextChallenge.js